module.exports = __webpack_public_path__ + "static/media/btRun.aff78dcd.png";